exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".registration-form .after-fields-content-wrapper {\n  margin-top: 8px; }\n  .registration-form .after-fields-content-wrapper .custom-r-r-link {\n    text-transform: none; }\n\n.registration-form .form-buttons-wrapper {\n  margin-top: 26px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/containers/Registration/Registration.scss
// module id = 1157
// module chunks = 0